<template>
  <section-divider-fi
    :fields="fields"
    :mark-ssr-only="markSsrOnly"
    size="small"
  />
</template>

<script setup lang="ts">
import type { MarkSsrOnly } from '@/composables/ssrOnly';
import type { SectionDividerSmallFiFields } from '@/generated/fields';

import SectionDividerFi from './SectionDividerFi.vue';

defineOptions({ name: 'SectionDividerSmallFi' });

interface Props {
  fields?: SectionDividerSmallFiFields | null;
  markSsrOnly?: MarkSsrOnly;
}
withDefaults(defineProps<Props>(), {
  fields: null,
  markSsrOnly: undefined,
});
</script>
